import { Navigate } from 'react-router-dom';
import { useContext } from 'react';
import AuthContext from '../context/AuthContext';

export const PrivateRoute = ({ children }) => {
  const { user } = useContext(AuthContext);
  const ki = localStorage.getItem('user');
  return !user ? <Navigate to="/login" /> : children;
};

export const PrivateRoute1 = ({ children }) => {
  const { user } = useContext(AuthContext);
  return user ? <Navigate to="/dashboard" /> : children;
};

export const PrivateRoute3 = ({ children, roleAllowed }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  let userRole;
  if (user.is_admin) {
    userRole = 'is_admin';
  } else if (user.is_commercial) {
    userRole = 'is_commercial';
  } else if (user.is_creche) {
    userRole = 'is_creche';
  }
  return roleAllowed && roleAllowed.indexOf(userRole) === -1 ? (
    <Navigate to="/dashboard/unauthorized" />
  ) : (
    children
  );
};
